'use client';

import classNames from 'classnames';
import { motion, AnimatePresence } from 'motion/react';

import Portal from 'app/components/common/Portal';
import { IconCross, IconDone } from '../sprites';
import { useEffect, useState } from 'react';

interface ICopyToClipboardNotificationProps {
  className?: string;
  isOpen?: boolean;
  onClose: () => void;
}

export const CopyToClipboardNotification = ({
  className,
  isOpen = false,
  onClose
}: ICopyToClipboardNotificationProps) => {
  return (
    <Portal>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            className={classNames(
              'fixed z-100 flex items-center p-3 text-p3 text-brown uppercase bg-gray rounded',
              className ?? 'top-0 right-3 md:right-6'
            )}
            initial="closed"
            animate="open"
            exit="closed"
            variants={{
              open: { opacity: 1, y: 93, transition: { duration: 0.5 } },
              closed: { opacity: 0, y: 0, transition: { duration: 0.5 } }
            }}
          >
            <div className="mr-6">
              <IconDone />
            </div>
            <p>Ссылка скопирована</p>
            <div className="ml-10 md:ml-17">
              <button className="p-2.5" onClick={onClose}>
                <IconCross />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </Portal>
  );
};
